import React, { useState, useEffect } from 'react';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import {
  Button,
  TextField,
  Tooltip,
  Container,
  Typography,
  InputAdornment,
  Box,
  Table,
  Modal,
  TableBody,
  TableCell,
  styled,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ProductMaster = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [showEditProductModal, setShowEditProductModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({
    productId: null,
    productName: '',
  });

  // Form states
  const [productCode, setProductCode] = useState('');
  const [mainCategory, setMainCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [brand, setBrand] = useState('');
  const [characteristics, setCharacteristics] = useState('');
  const [productName, setProductName] = useState('');
  const [productNameArabic, setProductNameArabic] = useState('');
  const [unit, setUnit] = useState('');
  const [purchasePrice, setPurchasePrice] = useState('');
  const [sellingPrice, setSellingPrice] = useState('');
  const [openingPrice, setOpeningPrice] = useState('');
  const [barCode, setBarCode] = useState('');
  const [promoDiscount, setPromoDiscount] = useState('');
  const [description, setDescription] = useState('');
  const [taxOption, setTaxOption] = useState('5%');
  const [inStock, setInStock] = useState('');

  // Static data for dropdowns and products
  const staticMainCategoryData = [
    { mainCategoryId: 1, mainCategory: 'Electronics' },
    { mainCategoryId: 2, mainCategory: 'Clothing' },
    { mainCategoryId: 3, mainCategory: 'Books' },
    { mainCategoryId: 4, mainCategory: 'Home & Kitchen' },
    { mainCategoryId: 5, mainCategory: 'Sports' },
    { mainCategoryId: 6, mainCategory: 'Toys' },
  ];

  const staticSubCategoryData = {
    'Electronics': [
      { subCategoryId: 1, subCategory: 'Smartphones' },
      { subCategoryId: 2, subCategory: 'Laptops' },
    ],
    'Clothing': [
      { subCategoryId: 3, subCategory: 'Men' },
      { subCategoryId: 4, subCategory: 'Women' },
    ],
    'Books': [
      { subCategoryId: 5, subCategory: 'Fiction' },
      { subCategoryId: 6, subCategory: 'Non-Fiction' },
    ],
    'Home & Kitchen': [
      { subCategoryId: 7, subCategory: 'Appliances' },
      { subCategoryId: 8, subCategory: 'Furniture' },
    ],
    'Sports': [
      { subCategoryId: 9, subCategory: 'Outdoor' },
      { subCategoryId: 10, subCategory: 'Indoor' },
    ],
    'Toys': [
      { subCategoryId: 11, subCategory: 'Educational' },
      { subCategoryId: 12, subCategory: 'Action Figures' },
    ],
  };

  const staticBrandData = {
    'Electronics': {
      'Smartphones': ['Samsung', 'Apple', 'Xiaomi'],
      'Laptops': ['Dell', 'HP', 'Lenovo'],
    },
    'Clothing': {
      'Men': ['Nike', 'Adidas', 'Puma'],
      'Women': ['Zara', 'H&M', 'Gucci'],
    },
    'Books': {
      'Fiction': ['Penguin', 'HarperCollins'],
      'Non-Fiction': ['Random House', 'Simon & Schuster'],
    },
    'Home & Kitchen': {
      'Appliances': ['Whirlpool', 'LG', 'Samsung'],
      'Furniture': ['IKEA', 'Ashley', 'Wayfair'],
    },
    'Sports': {
      'Outdoor': ['Nike', 'Adidas', 'Puma'],
      'Indoor': ['Decathlon', 'Nivia', 'Yonex'],
    },
    'Toys': {
      'Educational': ['LEGO', 'Mattel', 'Hasbro'],
      'Action Figures': ['Marvel', 'DC Comics', 'Star Wars'],
    },
  };

  const staticCharacteristicsData = {
    'Electronics': {
      'Smartphones': ['5G', 'AMOLED Display', 'Dual Camera'],
      'Laptops': ['Intel i7', '16GB RAM', 'SSD Storage'],
    },
    'Clothing': {
      'Men': ['Cotton', 'Breathable', 'Waterproof'],
      'Women': ['Silk', 'Lightweight', 'Stretchable'],
    },
    'Books': {
      'Fiction': ['Hardcover', '300 pages', 'Bestseller'],
      'Non-Fiction': ['Paperback', '250 pages', 'Educational'],
    },
    'Home & Kitchen': {
      'Appliances': ['Energy Efficient', 'Stainless Steel', 'Smart'],
      'Furniture': ['Wooden', 'Modern', 'Compact'],
    },
    'Sports': {
      'Outdoor': ['Durable', 'Lightweight', 'Water Resistant'],
      'Indoor': ['Comfortable', 'Breathable', 'Flexible'],
    },
    'Toys': {
      'Educational': ['STEM', 'Interactive', 'Safe'],
      'Action Figures': ['Collectible', 'Articulated', 'Detailed'],
    },
  };

  const staticUnitData = ['Piece', 'Box', 'Kilogram', 'Liter', 'Set'];

  const staticProductData = [
    {
      productId: 1,
      productCode: 'P001',
      mainCategory: 'Electronics',
      subCategory: 'Smartphones',
      brand: 'Samsung',
      characteristics: '5G',
      productName: 'Smartphone X',
      productNameArabic: 'هاتف ذكي X',
      unit: 'Piece',
      purchasePrice: 500,
      sellingPrice: 750,
      openingPrice: 600,
      barCode: '123456789012',
      promoDiscount: 10,
      description: 'High-end smartphone with 5G support',
      taxOption: '5%',
      inStock: 50,
    },
    {
      productId: 2,
      productCode: 'P002',
      mainCategory: 'Electronics',
      subCategory: 'Laptops',
      brand: 'Dell',
      characteristics: 'Intel i7',
      productName: 'Laptop Pro',
      productNameArabic: 'لاب توب برو',
      unit: 'Piece',
      purchasePrice: 1000,
      sellingPrice: 1500,
      openingPrice: 1200,
      barCode: '123456789013',
      promoDiscount: 15,
      description: 'Powerful laptop for professionals',
      taxOption: 'zero-rated',
      inStock: 30,
    },
    {
      productId: 3,
      productCode: 'P003',
      mainCategory: 'Clothing',
      subCategory: 'Men',
      brand: 'Nike',
      characteristics: 'Breathable',
      productName: 'Running Shoes',
      productNameArabic: 'أحذية الجري',
      unit: 'Piece',
      purchasePrice: 50,
      sellingPrice: 100,
      openingPrice: 80,
      barCode: '123456789014',
      promoDiscount: 5,
      description: 'Comfortable running shoes',
      taxOption: 'exempted',
      inStock: 0,
    },
    {
      productId: 4,
      productCode: 'P004',
      mainCategory: 'Books',
      subCategory: 'Fiction',
      brand: 'Penguin',
      characteristics: 'Hardcover',
      productName: 'Novel Book',
      productNameArabic: 'كتاب روائي',
      unit: 'Piece',
      purchasePrice: 10,
      sellingPrice: 20,
      openingPrice: 15,
      barCode: '123456789015',
      promoDiscount: 0,
      description: 'Bestselling fiction novel',
      taxOption: '5%',
      inStock: 100,
    },
    {
      productId: 5,
      productCode: 'P005',
      mainCategory: 'Home & Kitchen',
      subCategory: 'Appliances',
      brand: 'Whirlpool',
      characteristics: 'Energy Efficient',
      productName: 'Coffee Maker',
      productNameArabic: 'آلة صنع القهوة',
      unit: 'Piece',
      purchasePrice: 40,
      sellingPrice: 70,
      openingPrice: 50,
      barCode: '123456789016',
      promoDiscount: 10,
      description: 'Smart coffee maker',
      taxOption: 'zero-rated',
      inStock: 15,
    },
    {
      productId: 6,
      productCode: 'P006',
      mainCategory: 'Electronics',
      subCategory: 'Smartphones',
      brand: 'Apple',
      characteristics: 'Dual Camera',
      productName: 'Wireless Earbuds',
      productNameArabic: 'سماعات لاسلكية',
      unit: 'Piece',
      purchasePrice: 80,
      sellingPrice: 120,
      openingPrice: 100,
      barCode: '123456789017',
      promoDiscount: 5,
      description: 'High-quality wireless earbuds',
      taxOption: '5%',
      inStock: 45,
    },
  ];

  const [productData, setProductData] = useState(staticProductData);
  const [filteredData, setFilteredData] = useState(staticProductData);

  const handleAddProduct = () => {
    setProductCode('');
    setMainCategory('');
    setSubCategory('');
    setBrand('');
    setCharacteristics('');
    setProductName('');
    setProductNameArabic('');
    setUnit('');
    setPurchasePrice('');
    setSellingPrice('');
    setOpeningPrice('');
    setBarCode('');
    setPromoDiscount('');
    setDescription('');
    setTaxOption('5%');
    setInStock('');
    setShowAddProductModal(true);
  };

  const handleEdit = (product) => {
    setSelectedProduct({
      productId: product.productId,
      productName: product.productName,
    });
    setProductCode(product.productCode);
    setMainCategory(product.mainCategory);
    setSubCategory(product.subCategory);
    setBrand(product.brand);
    setCharacteristics(product.characteristics);
    setProductName(product.productName);
    setProductNameArabic(product.productNameArabic);
    setUnit(product.unit);
    setPurchasePrice(product.purchasePrice);
    setSellingPrice(product.sellingPrice);
    setOpeningPrice(product.openingPrice);
    setBarCode(product.barCode);
    setPromoDiscount(product.promoDiscount);
    setDescription(product.description);
    setTaxOption(product.taxOption);
    setInStock(product.inStock);
    setShowEditProductModal(true);
  };

  const handleShowDeleteModal = (productId, productName) => {
    setSelectedProduct({ productId, productName });
    setShowDeleteModal(true);
  };

  const handleDelete = () => {
    setProductData((prevProducts) =>
      prevProducts.filter((product) => product.productId !== selectedProduct.productId)
    );
    setSnackbarMessage(`${selectedProduct.productName} deleted successfully!`);
    setSnackbarSeverity('success');
    setOpenSnackbar(true);
    setShowDeleteModal(false);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (
      productCode &&
      mainCategory &&
      subCategory &&
      brand &&
      characteristics &&
      productName &&
      unit &&
      purchasePrice &&
      sellingPrice &&
      openingPrice &&
      barCode &&
      promoDiscount &&
      description &&
      inStock
    ) {
      const newProduct = {
        productId: productData.length + 1,
        productCode,
        mainCategory,
        subCategory,
        brand,
        characteristics,
        productName,
        productNameArabic,
        unit,
        purchasePrice: parseFloat(purchasePrice),
        sellingPrice: parseFloat(sellingPrice),
        openingPrice: parseFloat(openingPrice),
        barCode,
        promoDiscount: parseFloat(promoDiscount),
        description,
        taxOption,
        inStock: parseInt(inStock),
      };
      setProductData([...productData, newProduct]);
      setShowAddProductModal(false);
      setShowSuccessModal(true);
      handleReset();
    } else {
      setSnackbarMessage('Please fill all required fields');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleUpdate = () => {
    if (
      productCode &&
      mainCategory &&
      subCategory &&
      brand &&
      characteristics &&
      productName &&
      unit &&
      purchasePrice &&
      sellingPrice &&
      openingPrice &&
      barCode &&
      promoDiscount &&
      description &&
      inStock
    ) {
      const updatedProducts = productData.map((product) =>
        product.productId === selectedProduct.productId
          ? {
              ...product,
              productCode,
              mainCategory,
              subCategory,
              brand,
              characteristics,
              productName,
              productNameArabic,
              unit,
              purchasePrice: parseFloat(purchasePrice),
              sellingPrice: parseFloat(sellingPrice),
              openingPrice: parseFloat(openingPrice),
              barCode,
              promoDiscount: parseFloat(promoDiscount),
              description,
              taxOption,
              inStock: parseInt(inStock),
            }
          : product
      );
      setProductData(updatedProducts);
      setShowEditProductModal(false);
      setShowSuccessModal(true);
      handleReset();
    } else {
      setSnackbarMessage('Please fill all required fields');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleReset = () => {
    setProductCode('');
    setMainCategory('');
    setSubCategory('');
    setBrand('');
    setCharacteristics('');
    setProductName('');
    setProductNameArabic('');
    setUnit('');
    setPurchasePrice('');
    setSellingPrice('');
    setOpeningPrice('');
    setBarCode('');
    setPromoDiscount('');
    setDescription('');
    setTaxOption('5%');
    setInStock('');
  };

  const handleCancel = () => {
    setShowEditProductModal(false);
    handleReset();
  };

  const handleProductDetails = () => {
    setSnackbarMessage('Product Details button clicked');
    setSnackbarSeverity('info');
    setOpenSnackbar(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  useEffect(() => {
    setFilteredData(
      productData.filter(
        (product) =>
          product.productCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
          product.productName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          product.purchasePrice.toString().includes(searchTerm) ||
          product.sellingPrice.toString().includes(searchTerm) ||
          product.inStock.toString().includes(searchTerm)
      )
    );
  }, [searchTerm, productData]);

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:'space-between',
          mb: 1,
          p: 2,
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{display :'flex',justifyContent:'center',alignItems:'center',gap:2}}>
        <TextField
                           variant="outlined"
                           placeholder="Search..."
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                           InputProps={{
                             startAdornment: (
                               <InputAdornment position="start">
                                 <SearchIcon
                                   sx={{
                                     color: theme.palette.primary.main,
                                     marginLeft: 1.5,
                                     fontSize: 24,
                                   }}
                                 />
                               </InputAdornment>
                             ),
                             endAdornment: searchTerm && (
                               <InputAdornment position="end">
                                 <IconButton
                                   size="small"
                                   onClick={() => setSearchTerm('')}
                                   sx={{
                                     color: "grey",
                                     marginRight: 1,
                                   }}
                                 >
                                   <CloseIcon fontSize="small" />
                                 </IconButton>
                               </InputAdornment>
                             ),
                             sx: {
                               borderRadius: '30px',
                               backgroundColor: theme.palette.mode === 'dark'
                                 ? 'rgba(255, 255, 255, 0.15)'
                                 : 'rgba(255, 255, 255, 1)',
                               boxShadow: theme.palette.mode === 'dark'
                                 ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                 : '0 2px 8px rgba(0, 0, 0, 0.1)',
                               '& .MuiOutlinedInput-notchedOutline': {
                                 border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                               },
                               '&:hover': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.2)'
                                   : 'rgba(240, 240, 240, 1)',
                                 boxShadow: theme.palette.mode === 'dark'
                                   ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                   : '0 2px 12px rgba(0, 0, 0, 0.15)',
                               },
                               '&.Mui-focused': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.25)'
                                   : 'rgba(255, 255, 255, 1)',
                                 boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                 '& .MuiOutlinedInput-notchedOutline': {
                                   border: `2px solid ${theme.palette.primary.main}`,
                                 },
                               },
                               paddingLeft: 1.5,
                               height: '50px',
                               transition: 'all 0.3s ease',
                             },
                           }}
                           sx={{
                             width: 350,
                             maxWidth: '100%',
                             '& .MuiInputBase-input': {
                               padding: '10px 14px',
                               color: theme.palette.text.primary,
                               fontWeight: 500,
                             },
                           }}
                         />
          <Button
            variant="contained"
            onClick={()=>navigate("/add-product-master")}
            sx={{
              ml: 2,
              width: '180px',
              borderRadius:'10px',
              height: '50px',
              padding: '10px 0',
              fontWeight: 'bold',
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.dark },
            }}
            startIcon={<AddIcon />}
          >
            ADD PRODUCT
          </Button>
          </Box>
          <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={() => setShowUserGuideModal(true)}
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              minWidth: 0, // Remove MUI's default padding
            }}
          >
            <InfoOutlineIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
      </Box>

     <Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Product Code</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Product Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Purchase Price</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Selling Price</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>In Stock</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((product, index) => (
                    <TableRow
                      key={product.productId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{product.productCode}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{product.productName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>${product.purchasePrice}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>${product.sellingPrice}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{product.inStock}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => navigate(`/edit-product-master/${product.productId}`)}
                          sx={{
                            color: theme.palette.primary.light,
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleShowDeleteModal(product.productId, product.productName)}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}>
                    <TableCell colSpan={7} align="center" sx={{ fontSize: '1rem', padding: '20px',wordSpacing:7}}>
                      No  Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>

      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>
                Rows
              </InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Delete Modal */}
      <Modal
        open={showDeleteModal}
        onClose={handleCloseDeleteModal}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete <strong>{selectedProduct.productName}</strong>?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Add Product Modal */}
    <Modal
  open={showAddProductModal}
  onClose={() => setShowAddProductModal(false)}
  BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 700,
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      overflow: 'hidden',
      maxHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {/* Header (Fixed) */}
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        padding: '12px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
        Add Product
      </Typography>
      <IconButton onClick={() => setShowAddProductModal(false)} sx={{ color: '#fff' }}>
        <CloseIcon />
      </IconButton>
    </Box>

    {/* Scrollable Content */}
    <CustomTableScrollbar sx={{ flexGrow: 1, overflowY: 'auto' }}>
      <Box sx={{ padding: '20px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {/* Product Code and Main Category */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Product Code"
              variant="outlined"
              fullWidth
              value={productCode}
              onChange={(e) => setProductCode(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControl fullWidth>
              <InputLabel
                id="main-category-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Main Category
              </InputLabel>
              <Select
                labelId="main-category-label"
                id="main-category"
                value={mainCategory}
                label="Main Category"
                onChange={(e) => {
                  setMainCategory(e.target.value);
                  setSubCategory('');
                  setBrand('');
                  setCharacteristics('');
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticMainCategoryData.map((category) => (
                  <MenuItem key={category.mainCategoryId} value={category.mainCategory}>
                    {category.mainCategory}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* Sub Category and Brand */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel
                id="sub-category-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Sub Category
              </InputLabel>
              <Select
                labelId="sub-category-label"
                id="sub-category"
                value={subCategory}
                label="Sub Category"
                onChange={(e) => {
                  setSubCategory(e.target.value);
                  setBrand('');
                  setCharacteristics('');
                }}
                disabled={!mainCategory}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {mainCategory &&
                  staticSubCategoryData[mainCategory]?.map((subCat) => (
                    <MenuItem key={subCat.subCategoryId} value={subCat.subCategory}>
                      {subCat.subCategory}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel
                id="brand-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Brand
              </InputLabel>
              <Select
                labelId="brand-label"
                id="brand"
                value={brand}
                label="Brand"
                onChange={(e) => {
                  setBrand(e.target.value);
                  setCharacteristics('');
                }}
                disabled={!subCategory}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {subCategory &&
                  mainCategory &&
                  staticBrandData[mainCategory]?.[subCategory]?.map((brandItem) => (
                    <MenuItem key={brandItem} value={brandItem}>
                      {brandItem}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>

          {/* Characteristics and Product Name */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel
                id="characteristics-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Characteristics
              </InputLabel>
              <Select
                labelId="characteristics-label"
                id="characteristics"
                value={characteristics}
                label="Characteristics"
                onChange={(e) => setCharacteristics(e.target.value)}
                disabled={!brand}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {brand &&
                  subCategory &&
                  mainCategory &&
                  staticCharacteristicsData[mainCategory]?.[subCategory]?.map((char) => (
                    <MenuItem key={char} value={char}>
                      {char}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <TextField
              label="Product Name"
              variant="outlined"
              fullWidth
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          {/* Product Name (Arabic) and Unit */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Product Name (Arabic)"
              variant="outlined"
              fullWidth
              value={productNameArabic}
              onChange={(e) => setProductNameArabic(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControl fullWidth>
              <InputLabel
                id="unit-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Unit
              </InputLabel>
              <Select
                labelId="unit-label"
                id="unit"
                value={unit}
                label="Unit"
                onChange={(e) => setUnit(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticUnitData.map((unitItem) => (
                  <MenuItem key={unitItem} value={unitItem}>
                    {unitItem}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* Purchase Price and Selling Price */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Purchase Price"
              variant="outlined"
              fullWidth
              type="number"
              value={purchasePrice}
              onChange={(e) => setPurchasePrice(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Selling Price"
              variant="outlined"
              fullWidth
              type="number"
              value={sellingPrice}
              onChange={(e) => setSellingPrice(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          {/* Opening Price and Bar Code */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Opening Price"
              variant="outlined"
              fullWidth
              type="number"
              value={openingPrice}
              onChange={(e) => setOpeningPrice(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Bar Code"
              variant="outlined"
              fullWidth
              value={barCode}
              onChange={(e) => setBarCode(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          {/* Promo Discount and Description */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Promo Discount"
              variant="outlined"
              fullWidth
              type="number"
              value={promoDiscount}
              onChange={(e) => setPromoDiscount(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          {/* In Stock and Tax Option */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="In Stock"
              variant="outlined"
              fullWidth
              type="number"
              value={inStock}
              onChange={(e) => setInStock(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControl sx={{ my: 2 }}>
              <FormLabel
                id="tax-option-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Tax Option
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="tax-option-label"
                name="tax-option"
                value={taxOption}
                onChange={(e) => setTaxOption(e.target.value)}
              >
                <FormControlLabel value="5%" control={<Radio />} label="5%" />
                <FormControlLabel value="zero-rated" control={<Radio />} label="Zero-Rated" />
                <FormControlLabel value="exempted" control={<Radio />} label="Exempted" />
              </RadioGroup>
            </FormControl>
          </Box>

          {/* Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleProductDetails}
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
              }}
            >
              Product Details
            </Button>
            <Box>
              <Tooltip
                title={
                  !productCode
                    ? 'Enter Product Code'
                    : !mainCategory
                    ? 'Select Main Category'
                    : !subCategory
                    ? 'Select Sub Category'
                    : !brand
                    ? 'Select Brand'
                    : !characteristics
                    ? 'Select Characteristics'
                    : !productName
                    ? 'Enter Product Name'
                    : !unit
                    ? 'Select Unit'
                    : !purchasePrice
                    ? 'Enter Purchase Price'
                    : !sellingPrice
                    ? 'Enter Selling Price'
                    : !openingPrice
                    ? 'Enter Opening Price'
                    : !barCode
                    ? 'Enter Bar Code'
                    : !promoDiscount
                    ? 'Enter Promo Discount'
                    : !description
                    ? 'Enter Description'
                    : !inStock
                    ? 'Enter In Stock'
                    : ''
                }
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    onClick={handleSave}
                    sx={{
                      mr: 2,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.dark },
                    }}
                    disabled={
                      !productCode ||
                      !mainCategory ||
                      !subCategory ||
                      !brand ||
                      !characteristics ||
                      !productName ||
                      !unit ||
                      !purchasePrice ||
                      !sellingPrice ||
                      !openingPrice ||
                      !barCode ||
                      !promoDiscount ||
                      !description ||
                      !inStock
                    }
                  >
                    SAVE
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </CustomTableScrollbar>
  </Box>
</Modal>


      {/* Edit Product Modal */}
     <Modal
  open={showEditProductModal}
  onClose={handleCancel}
  BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 700,
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      overflow: 'hidden',
      maxHeight: '80vh',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {/* Header (non-scrollable) */}
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        padding: '12px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
        Edit Product
      </Typography>
      <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
        <CloseIcon />
      </IconButton>
    </Box>

    {/* Scrollable Form Content */}
    <CustomTableScrollbar sx={{ flexGrow: 1, overflowY: 'auto' }}>
      <Box sx={{ padding: '20px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {/* First Row */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Product Code"
              variant="outlined"
              fullWidth
              value={productCode}
              onChange={(e) => setProductCode(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControl fullWidth>
              <InputLabel
                id="main-category-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Main Category
              </InputLabel>
              <Select
                labelId="main-category-label"
                id="main-category"
                value={mainCategory}
                label="Main Category"
                onChange={(e) => {
                  setMainCategory(e.target.value);
                  setSubCategory('');
                  setBrand('');
                  setCharacteristics('');
                }}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticMainCategoryData.map((category) => (
                  <MenuItem key={category.mainCategoryId} value={category.mainCategory}>
                    {category.mainCategory}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* Second Row */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel
                id="sub-category-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Sub Category
              </InputLabel>
              <Select
                labelId="sub-category-label"
                id="sub-category"
                value={subCategory}
                label="Sub Category"
                onChange={(e) => {
                  setSubCategory(e.target.value);
                  setBrand('');
                  setCharacteristics('');
                }}
                disabled={!mainCategory}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {mainCategory &&
                  staticSubCategoryData[mainCategory]?.map((subCat) => (
                    <MenuItem key={subCat.subCategoryId} value={subCat.subCategory}>
                      {subCat.subCategory}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel
                id="brand-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Brand
              </InputLabel>
              <Select
                labelId="brand-label"
                id="brand"
                value={brand}
                label="Brand"
                onChange={(e) => {
                  setBrand(e.target.value);
                  setCharacteristics('');
                }}
                disabled={!subCategory}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {subCategory &&
                  mainCategory &&
                  staticBrandData[mainCategory]?.[subCategory]?.map((brandItem) => (
                    <MenuItem key={brandItem} value={brandItem}>
                      {brandItem}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>

          {/* Third Row */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel
                id="characteristics-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Characteristics
              </InputLabel>
              <Select
                labelId="characteristics-label"
                id="characteristics"
                value={characteristics}
                label="Characteristics"
                onChange={(e) => setCharacteristics(e.target.value)}
                disabled={!brand}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {brand &&
                  subCategory &&
                  mainCategory &&
                  staticCharacteristicsData[mainCategory]?.[subCategory]?.map((char) => (
                    <MenuItem key={char} value={char}>
                      {char}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <TextField
              label="Product Name"
              variant="outlined"
              fullWidth
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          {/* Fourth Row */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Product Name (Arabic)"
              variant="outlined"
              fullWidth
              value={productNameArabic}
              onChange={(e) => setProductNameArabic(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControl fullWidth>
              <InputLabel
                id="unit-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Unit
              </InputLabel>
              <Select
                labelId="unit-label"
                id="unit"
                value={unit}
                label="Unit"
                onChange={(e) => setUnit(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticUnitData.map((unitItem) => (
                  <MenuItem key={unitItem} value={unitItem}>
                    {unitItem}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {/* Fifth Row */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Purchase Price"
              variant="outlined"
              fullWidth
              type="number"
              value={purchasePrice}
              onChange={(e) => setPurchasePrice(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Selling Price"
              variant="outlined"
              fullWidth
              type="number"
              value={sellingPrice}
              onChange={(e) => setSellingPrice(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          {/* Sixth Row */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Opening Price"
              variant="outlined"
              fullWidth
              type="number"
              value={openingPrice}
              onChange={(e) => setOpeningPrice(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Bar Code"
              variant="outlined"
              fullWidth
              value={barCode}
              onChange={(e) => setBarCode(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          {/* Seventh Row */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Promo Discount"
              variant="outlined"
              fullWidth
              type="number"
              value={promoDiscount}
              onChange={(e) => setPromoDiscount(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
          </Box>

          {/* Eighth Row */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="In Stock"
              variant="outlined"
              fullWidth
              type="number"
              value={inStock}
              onChange={(e) => setInStock(e.target.value)}
              sx={{
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <FormControl sx={{ my: 2 }}>
              <FormLabel
                id="tax-option-label"
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-focused': { color: theme.palette.primary.main },
                }}
              >
                Tax Option
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="tax-option-label"
                name="tax-option"
                value={taxOption}
                onChange={(e) => setTaxOption(e.target.value)}
              >
                <FormControlLabel value="5%" control={<Radio />} label="5%" />
                <FormControlLabel value="zero-rated" control={<Radio />} label="Zero-Rated" />
                <FormControlLabel value="exempted" control={<Radio />} label="Exempted" />
              </RadioGroup>
            </FormControl>
          </Box>

          {/* Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleProductDetails}
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
              }}
            >
              Product Details
            </Button>
            <Box>
              <Tooltip
                title={
                  !productCode
                    ? 'Enter Product Code'
                    : !mainCategory
                    ? 'Select Main Category'
                    : !subCategory
                    ? 'Select Sub Category'
                    : !brand
                    ? 'Select Brand'
                    : !characteristics
                    ? 'Select Characteristics'
                    : !productName
                    ? 'Enter Product Name'
                    : !unit
                    ? 'Select Unit'
                    : !purchasePrice
                    ? 'Enter Purchase Price'
                    : !sellingPrice
                    ? 'Enter Selling Price'
                    : !openingPrice
                    ? 'Enter Opening Price'
                    : !barCode
                    ? 'Enter Bar Code'
                    : !promoDiscount
                    ? 'Enter Promo Discount'
                    : !description
                    ? 'Enter Description'
                    : !inStock
                    ? 'Enter In Stock'
                    : ''
                }
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    onClick={handleUpdate}
                    sx={{
                      mr: 2,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.dark },
                    }}
                    disabled={
                      !productCode ||
                      !mainCategory ||
                      !subCategory ||
                      !brand ||
                      !characteristics ||
                      !productName ||
                      !unit ||
                      !purchasePrice ||
                      !sellingPrice ||
                      !openingPrice ||
                      !barCode ||
                      !promoDiscount ||
                      !description ||
                      !inStock
                    }
                  >
                    UPDATE
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </CustomTableScrollbar>
  </Box>
</Modal>


      {/* Success Modal */}
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {showAddProductModal ? 'Product Added ✅' : 'Product Updated ✅'}
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              {showAddProductModal ? 'Product Added Successfully' : 'Product Updated Successfully'}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
  open={showUserGuideModal}
  onClose={() => setShowUserGuideModal(false)}
  BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 900,
      bgcolor: 'background.paper',
      borderRadius: '16px',
      boxShadow: 24,
      overflow: 'hidden',
    }}
  >
    {/* Header */}
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        padding: '12px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
        Product Master Management - User Guide
      </Typography>
      <IconButton
        onClick={() => setShowUserGuideModal(false)}
        sx={{ color: '#fff', position: 'absolute', right: 14 }}
      >
        <CloseIcon />
      </IconButton>
    </Box>

    {/* Scrollable Content */}
  <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
  {/* Section 1: Add Product */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
  >
    ➤ Follow these steps to add a new product:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Click the <strong>"ADD PRODUCT"</strong> button at the top to navigate to the Add Product page (<strong>/add-product-master</strong>).
    </li>
    <li>
      Fill in all required fields, including: <strong>Product Code</strong>, <strong>Main Category</strong> (select from dropdown), <strong>Sub Category</strong> (populated based on Main Category), <strong>Brand</strong> (populated based on Sub Category), <strong>Characteristics</strong> (populated based on Brand), <strong>Product Name</strong>, <strong>Product Name (Arabic)</strong>, <strong>Unit</strong>, <strong>Purchase Price</strong>, <strong>Selling Price</strong>, <strong>Opening Price</strong>, <strong>Bar Code</strong>, <strong>Promo Discount</strong>, <strong>Description</strong>, <strong>In Stock</strong>, and <strong>Tax Option</strong> (5%, Zero-Rated, or Exempted).
    </li>
    <li>
      Note the dependent dropdown behavior: selecting a Main Category enables Sub Category, selecting a Sub Category enables Brand, and selecting a Brand enables Characteristics.
    </li>
    <li>
      Before clicking the <strong>"SAVE"</strong> button, review all entered information carefully. The SAVE button remains disabled until all required fields are completed, with a tooltip indicating any missing fields.
    </li>
    <li>
      Click <strong>"SAVE"</strong> to add the product. A success message will confirm the addition.
    </li>
    <li>
      After saving, the new product record will appear in the Product List table.
    </li>
    <li>
      To clear all form fields, click the <strong>"RESET"</strong> button.
    </li>
    <li>
      Click <strong>"Product Details"</strong> for additional actions (currently displayed as a snackbar).
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: All fields except Product Name (Arabic) are mandatory. Numeric fields such as prices, discounts, and stock accept numbers only.
  </Typography>

  {/* Section 2: Edit Product */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to update an existing product:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Select the product you want to edit from the Product List table.
    </li>
    <li>
      Click the <strong>Edit</strong> icon (pencil) in the Action column to navigate to the Edit Product page (<strong>/edit-product-master/:id</strong>).
    </li>
    <li>
      Update the required fields such as Product Code, Category selections, Brand, Characteristics, Product Name, and pricing details. Dependent dropdown behavior remains the same as in Add Product.
    </li>
    <li>
      Before clicking the <strong>"UPDATE"</strong> button, ensure all mandatory fields are filled. Tooltips will guide you if any required field is missing.
    </li>
    <li>
      Click <strong>"UPDATE"</strong> to save the changes. A success message will confirm the update.
    </li>
    <li>
      To discard changes and exit without saving, click <strong>"CANCEL"</strong>.
    </li>
    <li>
      Click <strong>"Product Details"</strong> to access additional actions.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: All fields except Product Name (Arabic) are mandatory. Changing category selections will reset dependent fields.
  </Typography>

  {/* Section 3: Delete Product */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to delete a product:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Select the product you want to delete from the Product List table.
    </li>
    <li>
      Click the <strong>Delete</strong> icon (trash) in the Action column.
    </li>
    <li>
      Confirm the deletion by clicking <strong>"Yes, Delete"</strong> in the confirmation modal.
    </li>
    <li>
      The product will be removed from the list, and a success message will be displayed.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Deleted products cannot be recovered. Please proceed with caution.
  </Typography>

  {/* Section 4: Search Products */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to search for a product:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Use the search bar located at the top-left of the Product List.
    </li>
    <li>
      Enter the Product Code, Product Name, Purchase Price, Selling Price, or In Stock value (or part of it) to filter the results.
    </li>
    <li>
      The table will automatically update to display matching products.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Text searches are case-insensitive, while numeric fields require exact matches.
  </Typography>

  {/* Section 5: Pagination */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to navigate the product list:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Use the pagination controls at the bottom of the table to browse through products.
    </li>
    <li>
      Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
    </li>
    <li>
      Click a specific page number to jump directly to that page.
    </li>
    <li>
      Change the number of rows displayed per page using the dropdown menu (for example, 5, 10, 25, or 50 rows).
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Only the selected number of rows per page will be displayed in the table.
  </Typography>
</CustomTableScrollbar>

  </Box>
</Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default ProductMaster;